module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-use-vue-file-for-distribution-55.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-use-vue-file-for-distribution.md
// module id = 756
// module chunks = 178